import { Instagram } from "lucide-react";
import { Reveal, Chapter } from "./Reveal";

const WORKS = [
  { src: "/images/g-birthday.jpg", label: "Birthday", tall: true },
  { src: "/images/g-floral.jpg", label: "Floral", tall: false },
  { src: "/images/g-orchid.jpg", label: "Celebration", tall: true },
  { src: "/images/g-cupcakes.jpg", label: "Cupcakes", tall: false },
  { src: "/images/g-minimal.jpg", label: "Minimal & Elegant", tall: true },
  { src: "/images/g-macarons.jpg", label: "Macarons", tall: false },
  { src: "/images/g-graduation.jpg", label: "Theme & Character", tall: true },
  { src: "/images/g-drip.jpg", label: "Chocolate Drip", tall: false },
];

const Gallery = () => (
  <section id="work" className="scroll-mt-24 py-24 sm:py-32" data-testid="gallery-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <Chapter num="01" label="Featured Work" />
      </Reveal>
      <div className="mt-6 flex flex-wrap items-end justify-between gap-6">
        <Reveal delay={0.1}>
          <h2 className="max-w-xl font-display text-4xl font-light leading-tight tracking-tight text-[#2D2422] sm:text-5xl">
            Recent cakes from the studio
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <a
            href="https://www.instagram.com/bellabellscakes"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-outline"
            data-testid="gallery-instagram-btn"
          >
            <Instagram size={16} strokeWidth={1.5} /> See More on Instagram
          </a>
        </Reveal>
      </div>

      <div className="mt-14 columns-2 gap-4 sm:gap-6 lg:columns-4" data-testid="gallery-grid">
        {WORKS.map((w, i) => (
          <Reveal key={w.label} delay={(i % 4) * 0.08} className="mb-4 break-inside-avoid sm:mb-6">
            <figure
              className="group relative overflow-hidden rounded-2xl border border-[#E8D8D3]/60"
              data-testid={`gallery-item-${w.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            >
              <img
                src={w.src}
                alt={`${w.label} custom cake by Bella Bells Cakes, San Diego bakery`}
                loading="lazy"
                className={`w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105 ${
                  w.tall ? "aspect-[3/4]" : "aspect-square"
                }`}
              />
              <figcaption className="pointer-events-none absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#2D2422]/70 to-transparent p-4 opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                <span className="font-accent text-[11px] font-semibold uppercase tracking-[0.24em] text-white">
                  {w.label}
                </span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Gallery;
